import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const labelDefaultVariants = {}
const labelCompoundVariants = []

const labelSlotNames = [
  [
    "root",
    "label__root"
  ],
  [
    "requiredStar",
    "label__requiredStar"
  ]
]
const labelSlotFns = /* @__PURE__ */ labelSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, labelDefaultVariants, getSlotCompoundVariant(labelCompoundVariants, slotName))])

const labelFn = memo((props = {}) => {
  return Object.fromEntries(labelSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const labelVariantKeys = [
  "disabled",
  "error"
]
const getVariantProps = (variants) => ({ ...labelDefaultVariants, ...compact(variants) })

export const label = /* @__PURE__ */ Object.assign(labelFn, {
  __recipe__: false,
  __name__: 'label',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: labelVariantKeys,
  variantMap: {
  "disabled": [
    "true"
  ],
  "error": [
    "true"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, labelVariantKeys)
  },
  getVariantProps
})